(function($){
    $(document).ready(function(){
        var formint;
        var dis = setInterval(function(){
            if($('.disallow-items-container').length > 0){
                if($('.disallow-items-container').find('iframe').length <= 0){
                    $('.disallow-items-container').append('<iframe src="https://wodnosamolotem.pl/lista-przedmiotow-zabronionych/" />');

                }
            }
        }, 1000)

        var int = setInterval(function(){
            if($('#ldzan-checkin form [name="text-2"]').length > 0){
                // $('#ldzan-checkin form [name="text-2"]').addClass('invalid-qr');
                if($('#ldzan-checkin form [name="text-2"]').val().length < 8) {
                    $('.forminator-button-next').attr('disabled', 'disabled');
                    $('.forminator-button-next').removeClass('valid-qr');
                }
                else{
                    $('.forminator-button-next').removeAttr('disabled');
                }
                // clearInterval(int);
            }
        }, 10);



        $('body').on('click', '.forminator-button-next', function(e){
            if(!$(this).hasClass('valid-qr')){
                setTimeout(function(){
                    $('.forminator-button-back').click();
                    ldzan_checking_validate();
                    clearInterval(formint);
                }, 1)
            }
        })
        $('body').on('click', '#ldzan-checkin .forminator-pagination-steps *', function(e){
            if(!$('.forminator-button-next').hasClass('valid-qr')){
                formint = setTimeout(function(){
                    $('.forminator-button-back').click();
                    ldzan_checking_validate(true);
                }, 1)
            }
        })

    })

    function ldzan_checking_validate(nobefore = null){
        var next = $('.forminator-button-next').html(), intdot;
        $.ajax({
            url: ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'ldzan_checking_validate',
                'qr': $('#ldzan-checkin form [name="text-2"]').val(),
                'nonce': ajax_obj.nonce
            },
            beforeSend: function(){
                if(!nobefore) {
                    $('.forminator-button-next').html('');
                    intdot = setInterval(function () {
                        $('.forminator-button-next').html($('.forminator-button-next').html() + '.');
                    }, 1200)
                }
            },
            success: function (data) {
                console.log(data);
                clearInterval(intdot);
                $('.forminator-button-next').html(next);
                data = JSON.parse(data);
                if(data['result'] == 'ok') {
                    $('#ldzan-checkin form').attr('data-adults', data['adults']);
                    $('#ldzan-checkin form').attr('data-childs', data['childs']);
                    $('#ldzan-checkin form').attr('data-total', data['total']);
                    $('#ldzan-checkin form').attr('data-show-child-agreement', data['show-child-agreement']);
                    var i = 1;
                    var int = setInterval(function(){
                        $('#pax-total').html(data['total']);
                    }, 500)
                    $('#ldzan-checkin .persons select').val(data['total']).trigger('change');
                    if(data['show-child-agreement'] == 1){
                        $('#ldzan-checkin .has-childs select').val('one').trigger('change');
                    }
                    else{
                        $('#ldzan-checkin .has-childs select').val('two').trigger('change');
                    }
                    if(data['is_vip'] == 1){
                        $('#ldzan-checkin .persons').show();
                    }
                    else if(data['is_voucher'] == 1){
                        $('#ldzan-checkin .persons select').val('1');
                    }

                    if(data['total'] > 1){
                        $('.summary-pax-more').show();
                        $('.summary-pax-1').hide();
                    }
                    else{
                        $('.summary-pax-more').hide();
                        $('.summary-pax-1').show();
                    }
                    $('.forminator-button-next').addClass('valid-qr');
                    $('.forminator-button-next').click();
                }
                else{
                    $('.ldzan-qr-field .forminator-error-message').remove();
                    if(data['result'] == 'not_exists' || 1==1){
                        $('<div class="forminator-error-message" style="display: block">Voucher nie istnieje</div>').insertAfter('.ldzan-qr-field input');
                    }
                    else{
                        $('<div class="forminator-error-message" style="display: block">Voucher został już wykorzystany</div>').insertAfter('.ldzan-qr-field input');
                    }
                }
                // $('.forminator-button-next').attr('disabled', 'disabled');
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }
})(jQuery)